import { v4 as uuid } from 'uuid';

/**
 * Props for all StickyAlerts.
 * <br>
 * This is an interface because `defineProps` only works with interfaces.
 */
export interface StickyAlertPropsSchema {
  id: string;
}

/**
 * Helper class to create a legal set of props.
 */
export default class StickyAlertProps implements StickyAlertPropsSchema {
  id: string;

  constructor() {
    this.id = uuid();
  }
}
